module.exports = __webpack_public_path__ + "img/ico.668b9dc8.png";